export const SLIDER_CONFIG = {
  DRAG_THRESHOLD: 50,
  SLIDE_COUNT: 3,
  TRANSITION_DURATION: 300,
} as const;

